import { Controller } from "@hotwired/stimulus";
import Mark from "mark.js";

export default class extends Controller {
  static targets = ["content"];
  static values = { matches: { type: Array, default: [] } };

  connect() {
    if (this.hasMatchesValue && this.matchesValue.length > 0) {
      this.highlight();
    }
  }

  highlight() {
    this.contentTargets.forEach((element) => {
      const instance = new Mark(element);

      // Get the original text content
      const originalText = element.textContent.trim();

      // Process each match position
      this.matchesValue.forEach((match) => {
        const { start, length } = match;
        const textToHighlight = originalText.substring(start, start + length);

        instance.mark(textToHighlight, {});
      });
    });
  }
}
